import { Provider } from '@angular/core';
import { IFRAME_URL_WHITELIST } from './whitelist.token';

export const provideUrlWhitelist = (urlWhitelist: string[]): Provider => ({
  provide: IFRAME_URL_WHITELIST,
  useValue: urlWhitelist,
});
